module.exports = {
	"name": "mimiron2",
	"version": "1.0.1",
	"title": "Ant Design",
	"description": "一个 UI 设计语言",
	"homepage": "http://ant.design/",
	"keywords": [
		"ant",
		"design",
		"react",
		"react-component",
		"component",
		"components",
		"ui",
		"framework",
		"frontend"
	],
	"contributors": [
		"ant"
	],
	"bugs": {
		"url": "https://github.com/ant-design/ant-design/issues"
	},
	"main": "components/index",
	"files": [
		"components",
		"style"
	],
	"license": "MIT",
	"dependencies": {
		"array-tree-filter": "~1.0.0",
		"classnames": "~2.2.0",
		"css-animation": "~1.1.0",
		"gregorian-calendar": "~4.1.0",
		"gregorian-calendar-format": "~4.1.0",
		"object-assign": "~4.0.1",
		"rc-animate": "~2.0.2",
		"rc-calendar": "~5.4.0",
		"rc-cascader": "~0.9.0",
		"rc-checkbox": "~1.3.0",
		"rc-collapse": "~1.4.4",
		"rc-dialog": "~5.4.0",
		"rc-dropdown": "~1.4.3",
		"rc-form": "~0.14.0",
		"rc-form-validation": "~2.5.0",
		"rc-input-number": "~2.5.0",
		"rc-menu": "~4.10.2",
		"rc-notification": "~1.3.1",
		"rc-pagination": "~1.5.1",
		"rc-progress": "~1.0.4",
		"rc-queue-anim": "~0.11.2",
		"rc-radio": "~2.0.0",
		"rc-select": "~5.10.0",
		"rc-slider": "~3.3.0",
		"rc-steps": "~1.4.1",
		"rc-switch": "~1.3.2",
		"rc-table": "~3.11.1",
		"rc-tabs": "~5.8.0",
		"rc-time-picker": "~1.1.0",
		"rc-tooltip": "~3.3.1",
		"rc-tree": "~1.1.0",
		"rc-tree-select": "~1.4.1",
		"rc-trigger": "~1.2.0",
		"rc-upload": "~1.8.0",
		"rc-util": "~3.1.2",
		"react-slick": "^0.11.0",
		"velocity-animate": "~1.2.2",
		"warning": "~2.1.0"
	},
	"devDependencies": {
		"autoprefixer": "^6.3.3",
		"babel-cli": "^6.2.0",
		"babel-core": "^6.2.1",
		"babel-jest": "^6.0.1",
		"babel-loader": "^6.2.0",
		"babel-plugin-add-module-exports": "^0.1.1",
		"babel-preset-es2015": "^6.1.18",
		"babel-preset-react": "^6.1.18",
		"babel-preset-react-hmre": "^1.1.0",
		"babel-preset-stage-0": "^6.1.18",
		"busboy": "^0.2.9",
		"chalk": "^1.1.0",
		"css-loader": "^0.23.0",
		"cz-conventional-changelog": "^1.1.5",
		"es3ify-loader": "^0.1.0",
		"eslint": "^2.2.0",
		"eslint-config-airbnb": "^6.0.1",
		"eslint-plugin-babel": "^3.0.0",
		"eslint-plugin-markdown": "*",
		"eslint-plugin-react": "^4.0.0",
		"eslint-tinker": "^0.3.1",
		"extract-text-webpack-plugin": "^1.0.1",
		"gh-pages": "^0.9.0",
		"history": "^1.17.0",
		"instantclick": "^3.1.0",
		"jest-cli": "~0.8.0",
		"json-loader": "^0.5.1",
		"jsonp": "^0.2.0",
		"less": "~2.6.0",
		"less-loader": "^2.2.0",
		"lesshint": "^1.2.1",
		"lodash": "^4.1.0",
		"nico-jsx": "~0.9.0",
		"postcss-loader": "^0.8.0",
		"pre-commit": "1.x",
		"querystring": "^0.2.0",
		"rc-scroll-anim": "^0.1.7",
		"rc-tween-one": "^0.1.8",
		"react": "0.14.x",
		"react-addons-test-utils": "0.14.x",
		"react-copy-to-clipboard": "^4.0.1",
		"react-dom": "0.14.x",
		"react-router": "^2.0.0",
		"react-stateless-wrapper": "~1.0.2",
		"reqwest": "~2.0.5",
		"semver": "^5.1.0",
		"values.js": "^1.0.3",
		"webpack": "^1.10.1",
		"webpack-babel-jest": "^1.0.0",
		"webpack-dev-middleware": "^1.5.1",
		"webpack-hot-middleware": "^2.6.4"
	},
	"scripts": {
		"babel": "babel components index.js --out-dir lib",
		"start": "npm run clean && nico server --watch",
		"clean": "rm -rf _site dist",
		"site": "npm run clean && webpack --config webpack.deploy.config.js && webpack --config webpack.antd.config.js && NODE_ENV=PRODUCTION nico build",
		"deploy": "rm -rf node_modules && node scripts/install.js && npm run just-deploy",
		"just-deploy": "npm run site && node scripts/deploy.js",
		"lint": "eslint components test index.js --ext '.js,.jsx' && npm run mdlint && npm run lesshint",
		"mdlint": "eslint components/*/demo/*.md --ext '.md' --global 'React,ReactDOM,mountNode' --rule 'no-console: 0'",
		"lesshint": "lesshint style/ -e 'style/+(core|mixins)/+(base|iconfont|normalize|layouts|compatibility|grid).less'",
		"test": "npm run lint && webpack && npm run jest",
		"jest": "jest",
		"pub": "sh ./scripts/publish.sh",
		"webpack": "webpack",
		"beta": "sh ./scripts/publish.sh --tag beta",
		"debug": "node server.js",
		"release": "webpack --config webpack.config.release.js",
		"createcss": "webpack --config webpack.config.creatcss.js",
		"compilepages": "webpack --config webpack.config.compilepages.js"
	},
	"jest": {
		"testRunner": "<rootDir>/node_modules/jest-cli/src/testRunners/jasmine/jasmine2",
		"moduleFileExtensions": [
			"js",
			"jsx",
			"json"
		],
		"unmockedModulePathPatterns": [
			"<rootDir>/node_modules/*"
		],
		"testPathIgnorePatterns": [
			"/node_modules/",
			"/_site/"
		],
		"scriptPreprocessor": "<rootDir>/node_modules/webpack-babel-jest",
		"testDirectoryName": "tests",
		"preprocessCachingDisabled": false
	},
	"babel": {
		"presets": [
			"es2015",
			"react",
			"stage-0"
		],
		"plugins": [
			"add-module-exports"
		]
	},
	"directories": {
		"doc": "docs",
		"test": "tests"
	},
	"author": "Aether"
};


/*****************
 ** WEBPACK FOOTER
 ** ./package.json
 ** module id = 630
 ** module chunks = 0
 **/